import {
  Stack,
  Typography,
  Divider,
  IconButton,
  Collapse,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { RHFCheckbox } from "@app/components";
import { useState } from "react"; 

import { BrandsFiltersProps } from "../../types";

const BrandFilter = ({
  label,
  brands,
  openBrands,
  toggleBrand,
}: BrandsFiltersProps) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);
  return (
    <Stack spacing={1} sx={{ marginTop: 2.5 }}>
      {(
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          onClick={() => setDrawerOpen(!drawerOpen)}
        >
          <Typography
            sx={{
              color: theme.palette.grey[900],
              fontFamily: "Work Sans",
              fontWeight: 550,
            }}
          >
            {label}
          </Typography>
          <IconButton size="small">
            {drawerOpen ? (
              <Icon icon="mdi:chevron-up" width={20} height={20} />
            ) : (
              <Icon icon="mdi:chevron-down" width={20} height={20} />
            )}
          </IconButton>
        </Stack>
      )}

      <Collapse in={drawerOpen}>
        {brands?.map((brand) => (
        <Stack key={brand?.name}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              cursor: "pointer",
              "&:hover": { backgroundColor: theme.palette.grey[100] },
              p: 0.5,
              borderRadius: 1,
            }}
            onClick={(e) => {
              const target = e.target as HTMLElement;
              if (target.closest(".MuiCheckbox-root")) return;
              toggleBrand(brand?.name);
            }}
          >
            <RHFCheckbox
              name="brands"
              label={brand?.name}
              value={brand?.id}
              sx={{ "&.Mui-checked": { color: theme.palette.primary.main } }}
            />

            <IconButton size="small">
              {openBrands[brand.name] ? (
                <Icon icon="mdi:chevron-up" width={20} height={20} />
              ) : (
                <Icon icon="mdi:chevron-down" width={20} height={20} />
              )}
            </IconButton>
          </Stack>

          <Divider />

          <Collapse in={openBrands[brand?.name]}>
            <Stack pl={4} spacing={0.5} mt={0.5}>
              {brand?.models?.map((model:any) => (
                <RHFCheckbox
                  key={model.id}
                  name="models"
                  value={model.id}
                  label={model.name}
                  sx={{
                    "&.Mui-checked": { color: theme.palette.primary.main },
                  }}
                />
              ))}
            </Stack>
          </Collapse>
        </Stack>
      ))}

      </Collapse>
    </Stack>
  );
};

export { BrandFilter };
